var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48411 9.29413C1.8382 8.54594 1.8382 7.45408 2.48411 6.70589L2.76859 6.37636C5.50395 3.20789 10.4954 3.20789 13.2308 6.37636L13.5152 6.70589C14.1612 7.45408 14.1612 8.54594 13.5152 9.29413L13.2308 9.62366C10.4954 12.7921 5.50395 12.7921 2.76859 9.62366L2.27996 10.0455L2.76859 9.62366L2.48411 9.29413Z",
    stroke: "#CECECE",
    strokeWidth: 1.33333
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99967,
    cy: 8.00001,
    r: 2.66667,
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.3127cf155ef9508cbf34e60648e14d5f.svg";
export { ForwardRef as ReactComponent };